var SLIDE_ANIMATIONS = {
    SCROLL: 'SCROLL',
    FADE: 'FADE',
};
export default SLIDE_ANIMATIONS;
//# sourceMappingURL=slideAnimations.js.map